<template>
  <el-dialog
    :title="(detail.type === 'add' ? detail.titleName || '新增' : '编辑') + '产品线'"
    :visible.sync="isDialogVisible"
    :width="'500px'"
    append-to-body
    @close="cancelAddDialogVisible"
  >
    <div class="dialog-body addmember-body">
      <el-form
        label-width="160px"
        class="clearfix"
        ref="ruleForm"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="产品线：" prop="businessLine">
          <el-cascader
            v-if="detail.type !== 'edit'"
            ref="cascader"
            :options="allProductLine"
            :props="{
              value: 'id',
              label: 'name',
              children: 'productLineList',
            }"
            clearable
            :disabled="detail.type !== 'add'"
            placeholder="请选择"
            v-model="form.businessLine"
            @change="handleChange"
          >
          </el-cascader>
          <el-input
            v-else
            disabled
            class="search-input"
            placeholder=""
            v-model="form.businessLineName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="预计成交金额：" prop="dealAmount">
          <el-input
            class="search-input custom-right"
            placeholder="请输入"
            v-model="form.dealAmount"
          >
            <template slot="suffix">元</template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button :buttonType="'plain'" :text="'取消'" @click="cancelAddDialogVisible">
      </crm-button>
      <crm-button :text="'确定'" @click="handleEdit"></crm-button>
    </div>
  </el-dialog>
</template>
<script>
import service from "@/services/api/business";
import crmButton from "@/components/base/crmButton";
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    const dealAmountStrRule = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写预计成交金额!"));
      } else if (value < 0) {
        callback(new Error("请填写正数!"));
      } else if (!/^-?\d+\.?\d{0,2}$/.test(value)) {
        callback(new Error("请填写正数(最多两位小数)!"));
      } else if (parseFloat(value) > 99999999999.99) {
        callback(new Error("不能超过99,999,999,999.99"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      isDialogVisible: this.visible || false,
      form: {
        businessUid: this.detail.id || "",
        // 只带 id
        businessLine: [this.detail.businessLineId] || [],
        businessLineName: this.detail.name || "",
        dealAmount: this.detail.dealAmount || "",
      },
      allProductLine: [],
      rules: {
        dealAmount: [
          {
            required: true,
            validator: dealAmountStrRule,
            trigger: "change",
          },
        ],
        businessLine: {
          required: true,
        },
      },
    };
  },
  components: {
    crmButton,
  },
  props: {
    detail: Object,
    visible: Boolean,
    hasList: Array,
  },
  computed: {
    ...mapGetters({
      userInfo: "authority/userInfo",
    }),
  },
  mounted() {
    this.getAllProductLine();
  },
  methods: {
    // 获取用户列表
    /* eslint-disable */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 如果是新增编辑商机
          if (this.detail.titleName) {
            this.$emit("refresh", { ...this.form });
            this.cancelAddDialogVisible();
            return;
          }
          if (this.detail.type === "add") return this.handlerAdd();
          return this.handlerEdit();
        }
        return false;
      });
    },
    handlerAdd() {
      service
        .addProductLine({
          businessUid: this.form.businessUid,
          businessLine: this.form.businessLine[1],
          dealAmount: this.form.dealAmount,
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "添加产品线成功！",
          });
          this.cancelAddDialogVisible();
          this.$emit("refresh");
        });
    },
    handlerEdit() {
      service
        .updateProductLine({
          id: this.form.businessLine[0],
          dealAmount: this.form.dealAmount,
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改产品线成功！",
          });
          this.cancelAddDialogVisible();
          this.$emit("refresh");
        });
    },
    cancelAddDialogVisible() {
      this.isDialogVisible = false;
      this.form = {
        businessUid: "",
        businessLine: "",
        dealAmount: "",
      };
      this.allProductLine = [];
      this.resetForm();
      this.$emit("close");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    getAllProductLine() {
      service
        .queryProductLineList({
          salesmanCode: this.detail?.salesmanCode || this.userInfo?.userUid,
          customerId: this.detail?.customerId || "",
          contactDepaList: this.detail?.contactDepaList || [],
        })
        .then((res) => {
          res.data.data.forEach((item) => {
            this.allProductLine.push({
              ...item,
              id: item.typeCode,
              name: item.typeName,
            });
          });

          this.hasList &&
            this.hasList.forEach((i) => {
              this.allProductLine.forEach((item) => {
                if (i.typeName === item.typeName) {
                  item.productLineList.forEach((line) => {
                    if (line.id === i.productLineId) {
                      line.disabled = true;
                    }
                  });
                }
              });
            });
        });
    },
    handleChange() {
      const checkedNodes = this.$refs["cascader"].getCheckedNodes();
      this.form.businessLineName = checkedNodes[0].label;
    },
  },
};
</script>
<style lang="less" scoped>
ul {
  margin-left: -10px;
}
ul li {
  margin: 5px 0;
  font-weight: 500;
  font-size: 12px;
  color: #7a84b7;
}
/deep/ .el-select {
  width: 350px;
}
.custom-right /deep/.el-input__suffix {
  right: 110px;
}
</style>
